// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1kzf2A5tWmuBj3EclIYqgy","title":"_ARI2XZU532l_qwvTlhbt","modalButtonWrapper":"_1moO2xMUKqxJBVezw3__gs","messages":"eOm7R4rm3nblbXmqRK2yK","emptyButton":"jqGSCbAjFlYYHQnRfBaE7","textareaWrapper":"_3xoPYCMgHdK3HR-uiWVxes"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/MessageFromCompany.scss
// module id = 1700
// module chunks = 0